import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import s from "./CheckupTajikistan.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";
import Footer from "../../Components/Footer/Footer";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import { getTajikistanCheckupList } from "../../redux/InformationSlice";
import { Seo } from "../../Seo";

const CheckupTajikistan = () => {
  const checkupList = useSelector((state: RootState) => state.info.checkupList);
  const { width } = useWindowDimensions();
  const dispatch: AppDispatch = useDispatch();

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    dispatch(getTajikistanCheckupList());
  }, [dispatch]);

  return (
    <div>
      <Seo
        title="Анализы на ВИЧ в Таджикистане"
        description="Где пройти тесты на ВИЧ, туберкулез и сифилис в Таджикистане, адреса и телефоны"
        url="https://www.vputi.org/checkup/tajikistan"
      />
      ;
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}

        <div className={s.blue_buttons_wrapper}>
          <CountriesBlueButtons />
        </div>

        {checkupList?.map((it, index) => (
          <div className={s.block} key={index}>
            <img src={it?.image} className={s.icon} />
            <div className={s.title}>{it?.title}</div>
            <div className={s.subtitle}>{it?.description}</div>
            <div className={s.collapse}>
              {it.locations.map((el, locIndex) => (
                <Collapse
                  expandIcon={({ isActive }) => (
                    <DownOutlined
                      style={{
                        rotate: isActive ? "180deg" : "0deg",
                        fontSize: "14px",
                      }}
                    />
                  )}
                  expandIconPosition="end"
                  className={s.collapse_item}
                  items={[
                    {
                      key: "1",
                      label: (
                        <div className={s.collapse_title}>
                          <img
                            src="/images/Address.svg"
                            className={s.location_icon}
                          />{" "}
                          {el.location}
                        </div>
                      ),
                      children: (
                        <div className={s.collapse_children}>
                          {el.institutions.map((item, itemIndex) => (
                            <div>
                              <div className={s.location_name}>{item.name}</div>
                              <div className={s.location_address}>
                                {item.address}
                              </div>
                              <div className={s.location_phone}>
                                {item.phone}
                              </div>
                            </div>
                          ))}
                        </div>
                      ),
                    },
                  ]}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default CheckupTajikistan;
